import { render, staticRenderFns } from "./stage-view.vue?vue&type=template&id=5a60b213&scoped=true&"
import script from "./stage-view.vue?vue&type=script&lang=js&"
export * from "./stage-view.vue?vue&type=script&lang=js&"
import style0 from "./stage-view.vue?vue&type=style&index=0&id=5a60b213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60b213",
  null
  
)

export default component.exports